import { useEffect, useState } from 'react';
import { toast } from 'sonner';

const KEY = 'titan.keyStatus';
const NAME = { anthropic: 'Anthropic', openai: 'OpenAI' };
const subs = new Set();
const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; } };

/** Non-secret snapshot per provider: limits left (from response headers) and credit/rate exhaustion. */
export function reportKeyStatus(ks, { silent = false } = {}) {
  if (!ks?.provider) return;
  const all = { ...read(), [ks.provider]: ks };
  localStorage.setItem(KEY, JSON.stringify(all));
  subs.forEach((f) => f(all));
  if (silent) return;
  const msg = describe(ks);
  if (!msg) return;
  (ks.exhausted ? toast.error : toast.warning)(msg.title, { id: `key-${ks.provider}`, description: msg.body, duration: 10000 });
}

export function describe(ks) {
  const n = NAME[ks.provider] || ks.provider;
  if (ks.exhausted === 'credit') return { level: 'error', title: `Credito ${n} esaurito`, body: `Ricarica il tuo account ${n}: finché non lo fai le richieste vengono rifiutate.` };
  if (ks.exhausted === 'rate') return { level: 'error', title: `Limite di richieste ${n} raggiunto`, body: 'Attendi un minuto e riprova: il limite si ricarica da solo.' };
  if (ks.low?.length) {
    const parts = ks.low.map((k) => { const l = ks.limits?.[k]; return `${k === 'tokens' ? 'token' : 'richieste'} ${l ? `${l.remaining}/${l.limit}` : ''}`; });
    return { level: 'warn', title: `Chiave ${n} vicina al limite`, body: `Rimane meno del ${Math.round((ks.threshold || 0.2) * 100)}% (${parts.join(', ')}) nel periodo corrente del provider.` };
  }
  return null;
}

export const reportJobError = (provider, code) => {
  if (code === 'CREDIT_EXHAUSTED') reportKeyStatus({ provider, exhausted: 'credit', low: [], limits: {}, checked_at: new Date().toISOString() });
  else if (code === 'RATE_LIMIT') reportKeyStatus({ provider, exhausted: 'rate', low: [], limits: {}, checked_at: new Date().toISOString() });
};

export function useKeyStatus() {
  const [s, setS] = useState(read);
  useEffect(() => { subs.add(setS); return () => subs.delete(setS); }, []);
  return s;
}
